import { Truck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/* Bandeau défilant « Entrega hoy » — affiché juste au-dessus des produits.
   Une seule séquence d'items dans le DOM, dupliquée une fois (aria-hidden)
   pour la boucle continue. Pause au survol, statique si prefers-reduced-motion. */
export const DeliveryMarquee = () => {
    const { t } = useLang();
    const items = t("deliveryMarquee") || [];
    if (!items.length) return null;

    const Sequence = ({ hidden }) => (
        <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
            {items.map((label, i) => (
                <span key={i} className="flex items-center">
                    <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.18em] text-white">
                        {label}
                    </span>
                    <Truck className="mx-6 h-4 w-4 text-[#F2C4CE] shrink-0" strokeWidth={2.2} />
                </span>
            ))}
        </div>
    );

    return (
        <div
            data-testid="delivery-marquee"
            className="delivery-marquee relative z-10 w-full overflow-hidden bg-bordeaux-deep py-2.5"
        >
            <style>{`
                @keyframes delivery-marquee-scroll { from { transform: translateX(0); } to { transform: translateX(-50%); } }
                .delivery-marquee-track { animation: delivery-marquee-scroll 22s linear infinite; }
                .delivery-marquee:hover .delivery-marquee-track { animation-play-state: paused; }
                @media (prefers-reduced-motion: reduce) { .delivery-marquee-track { animation: none; } }
            `}</style>
            <div className="delivery-marquee-track flex w-max">
                <Sequence />
                <Sequence hidden />
            </div>
        </div>
    );
};
